export default __webpack_public_path__ + "static/media/navbar-sent-orange.430ea806.svg";